import { Select } from 'src/design/atoms/Select';
import React from 'react';
import { MilestonePhaseDto } from 'src/api/FiretrolApiClient';
import {
  useJobMilestonePhases,
  useTemplateMilestonePhases,
} from 'src/api/queries/milestones/useMilestonePhases';

const NO_PHASES: MilestonePhaseDto[] = [];

export interface IPhaseSelectorProps {
  value: string | null;
  onChange?: (value: string | null) => void;
  disabled?: boolean;
  jobId?: number;
  templateId?: string;
}

export const PhaseSelector: React.FC<IPhaseSelectorProps> = ({
  value,
  onChange,
  disabled,
  jobId,
  templateId,
}) => {
  const jobPhases = useJobMilestonePhases(jobId);
  const templatePhases = useTemplateMilestonePhases(templateId, !jobId);
  const options = (jobId ? jobPhases.data : templatePhases.data) ?? NO_PHASES;
  const loading = jobId ? jobPhases.isLoading : templatePhases.isLoading;

  const phaseData = React.useMemo(() => {
    return options.map((phase) => ({
      value: phase.id,
      label: phase.title,
    }));
  }, [options]);

  const handleChange = (selectedValue: string | null) => {
    if (onChange) {
      if (selectedValue) {
        onChange(selectedValue);
      } else {
        onChange(null);
      }
    }
  };

  return (
    <Select
      placeholder="Select Phase..."
      data={phaseData}
      value={value || null}
      onChange={handleChange}
      disabled={disabled || loading}
      clearable
      searchable
      nothingFoundMessage={loading ? 'Loading phases...' : 'No phases found'}
    />
  );
};
